import RootStore from '../RootStore/RootStore';
import API_URL from '../../config/ApiUrl';
import { makeAutoObservable } from 'mobx';
import { ServerGridConfig } from '../../config/GridConfig';
import axios from 'axios';

export default class AdmnSettingsStore {
	list_data = null;
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	adminSettingsDetail = null;
	searchValue = '';

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			// called by the grid when more rows are required
			getRows: (params) => {
				// get data for request from server
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue
				);
				this.getList(payload)
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};

	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.ADMIN_SETTINGS.LIST}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1`
			);
			return data.data;
		} catch {}
	};

	addAdminSetting = async (formData) => {
		return await axios
			.post(API_URL.ADMIN_SETTINGS.ADD, formData)
			.then(({ data }) => {
				this.setupGrid(this.agGrid);
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	deleteAdminSettings = async ({ id, versionNo }) => {
		try {
			const encodeURL =
				'?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.delete(
				API_URL.ADMIN_SETTINGS.DELETE + encodeURL
			);
			this.setupGrid(this.agGrid);
			return data.message;
		} catch (err) {
			Promise.reject(err);
		}
	};

	EditAdimnSettings = async (formData) => {
		return await axios
			.put(API_URL.ADMIN_SETTINGS.UPDATE, formData)
			.then(({ data }) => {
				this.setupGrid(this.agGrid);
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	ReadAdminSettings = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.ADMIN_SETTINGS.SINGLE + '?id=' + encodeURIComponent(id)
			);
			this.adminSettingsDetail = data.data;
			return data.data;
		} catch {}
	};
}
